const About = () => {
    return (
        <section className="flex flex-row items-center w-full justify-center mq450:h-auto bg-white">
        <div id="onas" className="flex flex-col max-w-[1280px] w-full justify-between px-[24px] gap-[80px] mq450:px-4  mq450:gap-[48px] h-full py-[96px] mq450:py-[32px]">
        <div id="top" className="flex flex-row mq450:flex-col gap-[64px] mq450:gap-[24px] justify-center items-end">
            <div id="left" className="flex flex-col w-full gap-[12px]">
                <div id="title" className='font-silka-semibold font-[600] text-[16px] leading-[130%] text-[#362F5B] mq450:text-[14px] uppercase'>O Nas</div>
                <div id="subtitle" className='font-silka-semibold font-[600] text-[40px] leading-[130%] text-[#362F5B] mq450:text-[24px]'>Co wyróżnia żelki Evera?</div>
            </div>
        </div>
        
        <div id="content" className="flex flex-row gap-[48px] items-center mq450:flex-col mq450:gap-[32px]">
        <div id="column" className="flex flex-col w-full gap-[48px] mq450:gap-[32px] mq450:order-1">
            <div className="flex flex-row items-center gap-[32px] mq450:gap-[24px]">
                <img src="/icon-1.svg" className="mq450:w-[48px]" />
                <div id="text" className="flex flex-col gap-[12px]">
                    <div id="title" className="text-[18px] font-silka-semibold font-[500] text-[#362F5B]">Skuteczność potwierdzona badaniami</div>
                    <div id="subtitle" className="text-[18px] font-silka-semibold font-[300] text-[#362F5B] mq450:text-[16px]">Formuły oparte na naukowo dobranych składnikach aktywnych.</div>
                </div>
            </div>
            <div id="line" className="flex w-full h-[1px] bg-[#362F5B]"></div>
            <div className="flex flex-row items-center gap-[32px] mq450:gap-[24px]">
                <img src="/icon-2.svg" className="mq450:w-[48px]"/>
                <div id="text" className="flex flex-col gap-[12px]">
                    <div id="title" className="text-[18px] font-silka-semibold font-[500] text-[#362F5B]">Dbałość o zdrowie i samopoczucie</div>
                    <div id="subtitle" className="text-[18px] font-silka-semibold font-[300] text-[#362F5B] mq450:text-[16px]">Produkty wspierające nie tylko ciało, ale też dobre samopoczucie i równowagę emocjonalną.</div>
                </div>
            </div>
            <div id="line" className="flex w-full h-[1px] bg-[#362F5B]"></div>
            <div className="flex flex-row items-center gap-[32px] mq450:gap-[24px]">
                <img src="/icon-3.svg" className="mq450:w-[48px]"/>
                <div id="text" className="flex flex-col gap-[12px]">
                    <div id="title" className="text-[18px] font-silka-semibold font-[500] text-[#362F5B]">Naturalne składniki</div>
                    <div id="subtitle" className="text-[18px] font-silka-semibold font-[300] text-[#362F5B] mq450:text-[16px]">Wegańska formuła bez sztucznych dodatków, cukru i GMO.</div>
                </div>
            </div>
            <div id="line" className="hidden mq450:flex w-full h-[1px] bg-[#362F5B]"></div>
        </div>
        
        <div id="image-container" className="mq450:order-3">
            <img src="/onas-img.svg" />
        </div>

        <div id="column" className="flex flex-col w-full gap-[48px] mq450:gap-[32px] mq450:order-2">
            <div className="flex flex-row items-center gap-[32px] mq450:gap-[24px]">
                <img src="/icon-6.svg" className="mq450:w-[48px]"/>
                <div id="text" className="flex flex-col gap-[12px]">
                    <div id="title" className="text-[18px] font-silka-semibold font-[500] text-[#362F5B]">Roślinna moc</div>
                    <div id="subtitle" className="text-[18px] font-silka-semibold font-[300] text-[#362F5B] mq450:text-[16px]">Wszystkie nasze żelki są w 100% roślinne — idealne dla wegan i wegetarian.</div>
                </div>
            </div>
            <div id="line" className="flex w-full h-[1px] bg-[#362F5B]"></div>
            <div className="flex flex-row items-center gap-[32px] mq450:gap-[24px]">
                <img src="/icon-7.svg" className="mq450:w-[48px]"/>
                <div id="text" className="flex flex-col gap-[12px]">
                    <div id="title" className="text-[18px] font-silka-semibold font-[500] text-[#362F5B]">Wsparcie umysłu i ciała</div>
                    <div id="subtitle" className="text-[18px] font-silka-semibold font-[300] text-[#362F5B] mq450:text-[16px]">Formuły wspomagające koncentrację, redukcję stresu i regenerację.</div>
                </div>
            </div>
            <div id="line" className="flex w-full h-[1px] bg-[#362F5B]"></div>
            <div className="flex flex-row items-center gap-[32px] mq450:gap-[24px]">
                <img src="/icon-8.svg" className="mq450:w-[48px]"/>
                <div id="text" className="flex flex-col gap-[12px]">
                    <div id="title" className="text-[18px] font-silka-semibold font-[500] text-[#362F5B]">Lepszy sen i regeneracja</div>
                    <div id="subtitle" className="text-[18px] font-silka-semibold font-[300] text-[#362F5B] mq450:text-[16px]">Suplementy pomagające osiągnąć spokojny sen i nocną regenerację organizmu.</div>
                </div>
            </div>
        </div>
        </div>


        </div>
      </section>
    );
};
  
export default About;
